import React from 'react';
import {
    ImageWrapSmall,
    TabsStyle,
    ContentSmallStyle,
    TabItemStyle,
    StickersWrapStyle,
    StickerStyle,
    CloseBlockStyle,
    StickerLeftStyle,
    StickerCornerStyle,
    WrapSmallStyle,
    RowtSmallStyle,
    RowtSmallLeftStyle,
    RowtSmallRightStyle,
    StickersSmallWrapStyle,
    BorderStyle
} from "./styles";
import Typography from "shared/Typography";
import TypographyWithIcon from "shared/TypographyWithIcon";
import Button from "shared/Button";
import Link from "shared/Link";
import {PartnerImage} from "modules/Partner/components";
import {DeliveryMethod} from "modules/Partner/enums/deliveryMethodEnum";
import combineLink from "helper/combineLink";
import links from "helper/links";

const PartnerItemSmall = ({
                   data,
                   //variant = 'primary',
                   isClose,
                   mb,
                   ...rest
                }) => {
    const {
        discountFlag,
        useKassa,
        useBonus,
        isClosed,
        promoGifts,
        name,
        rating,
        minSum,
        freeDeliverySum,
        deliveryDuration,
        reviewCount,
        deliveryCost,
        isNew,
        timeOut,
        deliveryMethod,
        id,
        alias
    } = data;
    const hasAction = !!promoGifts && promoGifts.find((item) => item.type !== 2);
    const deliveryText =
        freeDeliverySum > 0
            ? `Доставка бесплатно от ${freeDeliverySum} р`
            : `Доставка ${deliveryCost} р`;
    const isNewPartner = isNew === 1;

    const renderDeliveryItem = () => {
        switch (deliveryMethod?.key) {
            case DeliveryMethod.Edostav:
                return (
                    <TypographyWithIcon
                        iconWidth={10}
                        iconHeight={10}
                         variant='textSmall' icon='CourierIcon' color='green'>{deliveryDuration}</TypographyWithIcon>
                );
            case DeliveryMethod.Taxi:
                return (
                    <TypographyWithIcon
                        iconWidth={10}
                        iconHeight={10}
                         variant='textSmall' icon='TaxiIcon' color='green'>{deliveryDuration}</TypographyWithIcon>
                );
            default:
                return (
                    <Typography  variant='textSmall'  color='green'>{deliveryDuration}</Typography>
                );
        }
    };


    return (
        <Link
            key={id}
            href={combineLink(links.abs.partners, "[partnerId]")}
            as={combineLink(links.abs.partners, alias)}
        >
                <WrapSmallStyle
                    as={'a'}
                    //variant={variant}
                    isClose={isClose}
                    mb={mb}
                    data-cy='partner-item'
                    {...rest}
                >
                    <ImageWrapSmall isClose={isClose} >
                        <PartnerImage partner={data}/>
                    </ImageWrapSmall>
                    <ContentSmallStyle>
                        <Typography variant={'h4'} component="h2" mb={0.5}>{name}</Typography>
                        <RowtSmallStyle>
                            <RowtSmallLeftStyle>
                                <TypographyWithIcon
                                    iconWidth={10}
                                    iconHeight={10}
                                    color={'gray'} variant={'textSmall'} icon={'StarGoldIcon'}>
                                    {rating}
                                </TypographyWithIcon>
                            </RowtSmallLeftStyle>
                            <RowtSmallRightStyle>
                                <StickersSmallWrapStyle variant={'primary'}>
                                    {
                                        Boolean(useKassa) && (
                                            <StickerStyle>
                                                <Button size="small" isShadow variant='light' icon='MastercardIcon'></Button>
                                            </StickerStyle>
                                        )
                                    }

                                    {
                                        Boolean(useBonus) && (
                                            <StickerStyle>
                                                <Button size="small" isShadow variant='light' icon='BonusIcon'></Button>
                                            </StickerStyle>
                                        )
                                    }
                                </StickersSmallWrapStyle>
                            </RowtSmallRightStyle>
                        </RowtSmallStyle>

                        <RowtSmallStyle>
                            <RowtSmallLeftStyle>
                                <Typography  variant='textSmall'>Заказ от {minSum}р</Typography>
                            </RowtSmallLeftStyle>
                            <RowtSmallRightStyle>
                                {
                                    renderDeliveryItem()
                                }
                            </RowtSmallRightStyle>
                        </RowtSmallStyle>

                        <BorderStyle/>


                        <Typography
                            isFullWidth
                            align={'center'}
                            variant="text"
                            color='grayMid'
                            mb={0.5}>
                            {deliveryText}
                        </Typography>
                    </ContentSmallStyle>
                </WrapSmallStyle>
        </Link>
    );
};

export default PartnerItemSmall;
